import styled from 'styled-components';

// ----------------------------------------------------------------------

export const Container = styled.div`
  width: 100%;
  padding: 40px;
  position: relative;

  form {
    width: 460px;
    margin: 0 auto;

    select {
      width: 100%;
    }
    select:disabled {
      background-color: ${({theme}) => theme.colors.grayscale[50]};
      color: ${({theme}) => theme.colors.grayscale[400]};
    }

    > div {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
        margin-top: 30px;
      }
    }
  }
    
  ${({theme}) => theme.media.md`
    padding: 20px;

    form {
      width: 100%;
    }
  `};
`;

export const ListContainer = styled.div`
  width: 100%;
  padding: 40px 40px 40px 250px;

  form {
    width: 460px;
    margin: 0 auto;

    select {
      width: 100%;
    }
    select:disabled {
      background-color: ${({theme}) => theme.colors.grayscale[50]};
      color: ${({theme}) => theme.colors.grayscale[400]};
    }

    > div {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
        margin-top: 30px;
      }
    }
  }
    
  ${({theme}) => theme.media.xl`
    padding: 40px 40px 40px 210px;
  `};
    
  ${({theme}) => theme.media.md`
    padding: 20px;

    form {
      width: 100%;
    }
  `};
`;

export const SearchWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;

  .rangeBox {
    width: 100%;
    display: flex;
    border-radius: 8px;
    background-color: #FFFFFF;

    &.disabled {
      background-color: #F7F8FA;
    }

    .range {
      width: 22px;
      text-align: center;
      line-height: 40px;
      font-size: 18px;
    }

    .calendarStart {
      width: calc((100% - 22px) / 2 - 24px);
    }

    .calendarEnd {
      width: calc((100% - 22px) / 2 + 24px);
    }

    .calendarStart .dx-texteditor-buttons-container {
      display: none;
    }

    .dx-texteditor-input {
      padding-left: 0;
      padding-right: 0;
    }
  }
  

  > div:first-child {
    flex-wrap: wrap;

    > select {
      width: 150px;
      margin-right: 4px;
    }

    > input {
      width: 300px;
      padding: 0 20px;
      border-radius: 8px;
      border: 1px solid ${({theme}) => theme.colors.grayscale[200]};
    }
  }
  
  > div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
    
  ${({theme}) => theme.media.xxl`
    display: block;

    > div:first-child {
      margin-bottom: 10px;
    }

    > div:last-child {
      justify-content: flex-end;
    }
  `};
    
  ${({theme}) => theme.media.mlg`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    > div:first-child {
      width: 100%;
      flex-direction: column;
      align-items: stretch;
      margin-bottom: 0;

      > select, > input {
        width: 100%;
      }
    }
  `};
    
  ${({theme}) => theme.media.md`
    > div:last-child {
      width: 100%;
      flex-direction: column;
      > button {
        width: 100%;
      }
    }
  `};
`;

export const Tabs = styled.div`
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 5px 0 rgba(38, 51, 77, 0.03);

  > button {
    background-color: #FFFFFF;
    padding: 0 20px;
  }
  > button.active {
    color: #FFFFFF;
    background-color: ${({theme}) => theme.colors.grayscale[800]};
  }
    
  ${({theme}) => theme.media.mlg`
    width: 100%;

    > button {
      width: 25%;
      padding: 0;
    }
  `};
`;

export const FormTabs = styled.div`
  margin-bottom: 4px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  
  ${Tabs} {
    width: fit-content;
    box-shadow: none;
    border: 1px solid ${({theme}) => theme.colors.grayscale[200]}80;

    > button {
      height: 32px;
      font-size: 13px;
    }
    > button:disabled {
      color: #C3CAD9;
      background-color: #F7F8FA;
    }
  }
  
  p {
    font-size: 12px;
    color: ${({theme}) => theme.colors.grayscale[400]};
    line-height: 20px;
  }
    
  ${({theme}) => theme.media.mlg`
    ${Tabs} button {
      width: auto;
      padding: 0 10px;
    }
  `};
`;

export const Box = styled.div`
  width: 100%;
  border-radius: 20px;
  padding: 20px;
  background-color: #FFFFFF;
    
  ${({theme}) => theme.media.md`
    padding: 20px 10px;
  `};
`;

/* SELECT BUTTON */
export const SelectButton = styled.button`
  border: 1px solid ${({theme}) => theme.colors.grayscale[100]};
  background-color: #FFFFFF;
  border-radius: 8px;
  text-align: left;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div:last-child {
    width: 24px;
    height: 24px;
    background-image: url(/assets/base/chevron.svg);
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
    margin-left: 10px;
  }

  > p {
    width: calc(100% - 34px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  > button {
    width: 49%;
  }
`;

/* INPUT */
export const SearchInput = styled.div<{ $disabled?: boolean }>`
  width: 300px;
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.colors.grayscale[200]};
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.$disabled ? '#F7F8FA' : '#FFFFFF'};

  &:focus-within {
    border: 1px solid ${({theme}) => theme.colors.primary[500]};
    > svg {
      stroke: ${({theme}) => theme.colors.grayscale[600]};
    }
  }
  > input {
    border: none;
    width: calc(100% - 34px);
  }
  > svg {
    stroke: ${({theme}) => theme.colors.grayscale[200]};
  }
`;

/* POPOVER */
export const SearchPopover = styled.div`
  ${SearchInput} {
    width: 200px;
    margin: 12px 8px 20px 8px;
  }
  button {
    text-align: left;
  }
  button.last {
    display: flex;
    align-items: center;
    justify-content: center;
    > div {
      width: 24px;
      height: 24px;
      background-image: url(/assets/base/chevron.svg);
      background-size: 24px 24px;
      background-position: right center;
      background-repeat: no-repeat;
      margin-left: 10px;
    }
  }

  > p {
    width: 100%;
    display: block;
    color: #6B7A99;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    border-top: 1px solid #F2F3F5;
  }
`;

export const AnalysisPopover = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 10px;

  > button:last-child {
    width: 100%;
  }

  .rangeBox {
    width: 100%;
    display: flex;
    border-radius: 8px;
    background-color: #FFFFFF;

    &.disabled {
      background-color: #F7F8FA;
    }

    .range {
      width: 22px;
      text-align: center;
      line-height: 40px;
      font-size: 18px;
    }

    .calendarStart {
      width: calc((100% - 22px) / 2 - 24px);
    }

    .calendarEnd {
      width: calc((100% - 22px) / 2 + 24px);
    }

    .calendarStart .dx-texteditor-buttons-container {
      display: none;
    }

    .dx-texteditor-input {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

export const StateTitle = styled.p`
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
`;

export const SensorFormWapper = styled.div`
  width: 540px;
  margin: 0 auto;

  .box {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 20px;
  }

  ${Tabs} {
    box-shadow: none;
    border-radius: 0;
    margin-bottom: 10px;
    overflow: hidden;
    border-radius: 8px 8px 0 0;

    button {
      border-right: 2px solid ${({theme}) => theme.colors.grayscale[100]};

      &:first-child {
        border-radius: 8px 0 0 0;
      }
      &:last-child {
        border-radius: 0 8px 0 0;
        border-right: none;
      }
    }
  }

  ${SelectButton} {
    width: 100%;
  }
    
  ${({theme}) => theme.media.md`
    width: 100%;
  `};
`;

export const Tags = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;

  div {
    background-color: ${({theme}) => theme.colors.primary[500]}0F;
    width: fit-content;
    display: flex;
    align-items: center;
    padding: 0 16px;
    height: 40px;
    border-radius: 20px;
    gap: 4px;
    color: ${({theme}) => theme.colors.primary[400]};
  }

  button {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  svg {
    width: 18px;
    height: 18px;
    stroke: ${({theme}) => theme.colors.primary[400]};
  }
`;

// ----------------------------------------------------------------

export const Message = styled.div<{ $visible: boolean }>`
  font-size: 12px; 
  color: ${({theme}) => theme.colors.error};
  white-space: pre-wrap;
  line-height: 18px;
  display: flex;
  margin: 20px 0 20px;
  text-align: left;

  &:before {
    content: '';
    display: ${(props) => props.$visible ? 'block' : 'none'};
    width: 16px;
    height: 16px;
    background-image: url(/assets/form/error.png);
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 2px;
  }
`;

export const InfoMessage = styled.p`
  font-size: 12px; 
  color: ${({theme}) => theme.colors.info};
  white-space: pre-wrap;
  line-height: 18px;
  display: flex;
  margin-top: 2px;

  &:before {
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    background-image: url(/assets/form/info.png);
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: 2px;
  }
`;

export const TempContent = styled.div`
  display: flex;
  text-align: left;
  border-top: 1px solid ${({theme}) => theme.colors.grayscale[100]};
  border-bottom: 1px solid ${({theme}) => theme.colors.grayscale[100]};
  margin-top: 40px;
  padding: 20px 25px;

  p {
    width: 40%;
    line-height: 35px;
    color: ${({theme}) => theme.colors.grayscale[500]};
  }
  span {
    line-height: 35px;
    font-size: 16px;
    color: ${({theme}) => theme.colors.grayscale[700]};
  }
`;

export const DevicesContent = styled.div`
  width: 460px;
  text-align: left;

  > p:first-child {
    color: ${({theme}) => theme.colors.grayscale[700]};
    font-size: 16px;
    padding-bottom: 10px;
  }
  
  ${Tabs} {
    box-shadow: none;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid ${({theme}) => theme.colors.grayscale[100]};
    margin-bottom: 20px;

    button {
      width: 33.333%;
    }
    button:not(.active) {
      background-color: ${({theme}) => theme.colors.grayscale[50]};
    }
  }

  > button:last-child {
    width: 100%;
    margin-top: 30px;
  }

  &.mobile {
    width: calc(100vw - 80px);
  }
`;

export const GeneralContent = styled.div`
  select {
    width: 100%;
  }

  > div {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
      margin-top: 30px;
    }
  }
`;

export const Radio = styled.div`
  display: flex;
  gap: 40px;

  label {
    display: flex;
    align-items: center;
    width: auto;
    gap: 4px;
  }
`;

export const Status = styled.div`
  display: flex;
  gap: 40px;
  justify-content: center;
  margin-bottom: 20px;
  flex-wrap: wrap;

  > div {
    display: flex;
    gap: 40px;
    

    &:first-child button:first-child {
      background-color: ${({theme}) => theme.colors.primary[400]};
      > div:first-child > div {
        background-image: url(/assets/status/total.svg);
      }
    }

    &:first-child button:last-child {
      background-color: ${({theme}) => theme.colors.grayscale[500]};
      > div:first-child > div {
        background-image: url(/assets/status/signal.svg);
      }
    }

    &:last-child button:first-child {
      background-color: ${({theme}) => theme.colors.error};
      > div:first-child > div {
        background-image: url(/assets/status/sensor.svg);
      }
    }

    &:last-child button:last-child {
      background-color: ${({theme}) => theme.colors.yellow};
      > div:first-child > div {
        background-image: url(/assets/status/battery.svg);
      }
    }
  }

  button {
    width: 236px;
    height: 108px;
    border-radius: 20px;
    padding: 10px 10px 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    > div:first-child {
      display: flex;
      flex-direction: column;
      align-items: center;

      > div {
        width: 40px;
        height: 40px;
        background-size: 100% auto;
        background-position: center center;
        background-repeat: no-repeat;
      }
      > p {
        color: #FFFFFF;
        font-size: 18px;
        line-height: 26px;
        letter-spacing: -0.8px;
        white-space: nowrap;
      }
    }
    
    > div:last-child {
      width: 120px;
      height: 88px;
      border-radius: 20px;
      color: ${({theme}) => theme.colors.grayscale[700]};
      background-color: #FFFFFF;
      font-size: 40px;
      font-weight: 800;
      line-height: 88px;
    }
  }
    
  ${({theme}) => theme.media.md`
    flex-direction: column;

    > div {
      flex-direction: column;

      > button {
        width: 100%;

        > div:first-child, > div:last-child {
          width: 50%;
        }
      }
    }
  `};
`;

export const SensorTable = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 20px;

  td {
    div {
      width: 100%;
      border: 1px solid ${({theme}) => theme.colors.grayscale[200]};
      border-right: none;
      height: 40px;
      line-height: 40px;
      background-color: ${({theme}) => theme.colors.grayscale[100]};

      &:last-child {
        border-top: none;
        background-color: #FFFFFF;
      }

      &.error {
        font-weight: 600;
        color: ${({theme}) => theme.colors.error};
      }
    }
    
    &:last-child div {
      border-right: 1px solid ${({theme}) => theme.colors.grayscale[200]};
    }
  }
`;

export const RealTimeTopWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 80px;
  
  > div:last-child {
    margin-bottom: 30px;
  }
`;

export const RealTimeTabs = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 25px;

  > button {
    font-size: 16px;
    color: #4D5E80;
    display: flex;
    align-items: center;
    gap: 5px;
    box-sizing: border-box;
    border-bottom: 2px solid transparent;
  }
  > button.active {
    border-bottom: 2px solid #4D5E80;
  }
`;

export const RealTimeContent = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const RealTimeChart = styled.div`
  width: 386px;
  height: 392px;
  background-color: #FFFFFF;
  border-radius: 20px;
  padding: 20px;

  > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;

    > p {
      font-size: 16px;
      color: ${({theme}) => theme.colors.grayscale[800]};
      font-weight: 600;
    }

    > div:last-child {
      display: flex;
      gap: 10px;

      button {
        width: 32px;
        height: 32px;
        border-radius: 4px;

        &:hover {
          background-color: #3361FF0F;
        }
      }
    }
  }
    
  ${({theme}) => theme.media.lg`
    width: calc(50% - 10px);
  `};
    
  ${({theme}) => theme.media.slg`
    width: 100%;
  `};
`;

export const LocationChart = styled.div`
  width: 520px;
  background-color: #FFFFFF;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  > div:not(:last-child) {
    margin: 0 10px;
  }

  > div:first-child {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #F2F3F5;

    > p {
      color: #3E4F70;
      font-size: 20px;
      font-weight: 600;
    }

    > div {
      display: flex;
      align-items: center;

      > p {
        color: #7D8FB3;
        display: flex;
        align-items: center;

        &::after {
          content: '';
          display: block;
          width: 1px;
          height: 14px;
          background: #F2F3F5;
          margin: 0 12px;
        }
      }

      > button svg {
        width: 30px;
        height: 30px;
      }
    }
  }

  > div:not(:first-child) {
    display: flex;
    flex-direction: column;
    gap: 10px;

    > p {
      color: #4D5E80;
      font-size: 15px;
      line-height: 22px;
      display: flex;
      align-items: center;
      gap: 6px;

      &::before {
        content: '';
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #4D5E80;
      }
    }

    > div {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      row-gap: 10px;

      > div {
        display: flex;
        flex-direction: column;
        gap: 4px;
        width: 25%;

        > p {
          color: #7D8FB3;
          line-height: 20px;
          display: flex;
          align-items: center;
          gap: 4px;

          &.alarm::after {
            content: 'A';
            display: block;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #FF6914;
            text-align: center;
            color: #FFFFFF;
            font-size: 12px;
            font-weight: 600;
          }
        }

        > div {
          height: 28px;
          display: flex;
          align-items: flex-end;
          gap: 4px;

          p {
            color: #4D5E80;
            font-size: 18px;
            font-weight: 600;
            line-height: 28px;
          }

          span {
            color: #6B7A99;
            font-size: 12px;
            line-height: 20px;
          }
        }
      }
    }
  }

  > div:last-child {
    > p {
      padding-left: 10px;
    }

    > div {
      padding: 20px;
      border-radius: 20px;
      border: 1px solid #F2F3F5;
      background: #F7F8FA;
    }
  }
    
  ${({theme}) => theme.media.mlg`
    width: 100%;

      > div:first-child {
    height: auto;
    display: block;
    > div {
    justify-content: space-between;
     }
       }

       > div:not(:first-child) {
        > div {
    row-gap: 20px;
         > div {
         width: 50%;
         }
        }
        }
  `};
`;

export const StatusPopover = styled.div`
  padding: 20px;
  display: flex;

  p {
    text-align: center;
    line-height: 49px;
    padding: 0 5px;
    border-bottom: 1px solid ${({theme}) => theme.colors.grayscale[100]};
  }

  > div:last-child > div {
    display: flex;
    height: 50px;
    align-items: center;
    padding: 0 5px;
    border-bottom: 1px solid ${({theme}) => theme.colors.grayscale[100]};

    div {
      margin-left: 8px;
    }
  }
`;

export const StatusIcon = styled.div<{ $icon: string }>`
  width: 24px;
  height: 24px;
  background-image: url(/assets/real-time/${(props) => props.$icon}.svg);
  background-size: auto auto;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;

  span {
    padding: 5px 10px;
    background-color: #4D5E80F2;
    border-radius: 4px;
    color: #F2F3F5;
    font-size: 12px;
    white-space: nowrap;
    position: absolute;
    top: -30px;
    right: 0;
    display: none;
  }

  &:hover span {
    display: block;
  }
`;

export const LinePopover = styled.div`
  > p {
    font-size: 14.5px;
    font-weight: 500;
    line-height: 24px;
    padding: 2px 15px 8px;
    border-bottom: 1px dashed ${({theme}) => theme.colors.grayscale[500]}52;
  }
  
  > label {
    padding: 10px 15px;

    display: block;
    width: 100%;
    display: flex;
    align-items: center;

    &:hover, &:active {
      background-color: ${({theme}) => theme.colors.grayscale[500]}0D;
    }

    > label {
      margin-right: 5px;
    }
  }
`;

export const RangesPopover = styled.div`
  > p {
    font-size: 14.5px;
    font-weight: 500;
    line-height: 24px;
    padding: 2px 15px 8px;
    border-bottom: 1px dashed ${({theme}) => theme.colors.grayscale[500]}52;
  }

  > div {
    padding: 10px 15px;

    > div {
      > div:first-child {
        margin-bottom: 5px;
      }

      > div:last-child {
        display: flex;
        align-items: flex-start;

        > input {
          width: 85px;
          height: 34px;
          padding: 0 10px 0 15px;
        }

        p {
          width: 15px;
          height: 30px;
          line-height: 30px;
          color: #6B7A99;
          font-size: 16px;
          text-align: center;
          margin-bottom: 4px;
        }
      }
    }

    > button {
      color: #FFFFFF;
      margin-top: 10px;
    }
  }
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;

  button {
    padding: 2px 5px;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;
    height: auto;
  }
`;

export const ScrollBar = styled.div`
  width: 100%;
  height: 100%;
  overflow: overlay;

  &::-webkit-scrollbar {
    width: 20px;
    height: 20px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 115, 129, 0.3);
    border-radius: 10px;
    background-clip: padding-box;
    border: 8px solid transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const MobileDateWrapper = styled.div`
  display: flex;
  gap: 5px;

  ${({theme}) => theme.media.mlg`
    width: 100%;
    justify-content: space-between;

    .dx-datebox, .dx-daterangebox {
      width: calc(100% - 90px);
    }
  `};

  .rangeBox {
    width: calc(100% - 90px);
    display: flex;
    border-radius: 8px;
    background-color: #FFFFFF;

    .range {
      width: 22px;
      text-align: center;
      line-height: 40px;
      font-size: 18px;
    }

    .calendarStart {
      width: calc((100% - 22px) / 2 - 24px);
    }

    .calendarEnd {
      width: calc((100% - 22px) / 2 + 24px);
    }

    .calendarStart .dx-texteditor-buttons-container {
      display: none;
    }

    .dx-texteditor-input {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

export const DateButton = styled.button<{ $next?: boolean }>`
  width: 40px;
  height: 40px;
  background-image: url(/assets/pagination/arrow.svg);
  background-size: 24px 24px;
  background-position: center center;
  background-repeat: no-repeat;
  transform: ${(props) => props.$next ? 'rotate(180deg)' : 'none'};
  border-radius: 8px;
  background-color: #FFFFFF;
  border: 1px solid #C3CAD9;

  &:disabled {
    background-color: #F7F8FA;
  }
`;

export const CustomDateBox = styled.button`
  width: calc(100% - 90px);
  border: none;
  border-radius: 8px;
  height: 40px;
  box-shadow: 0 2px 5px 0 rgba(38, 51, 77, 0.03);
  background: #FFFFFF;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 0 9px;
  justify-content: space-between;
  
  > p {
    width: calc(100% - 32px);
    text-align: center;
  }
`;